module.exports = __webpack_public_path__ + "files/7ce77bbb5d503b27dbbfaf382e8902fb.png";